import { TypeLeurre } from './type-leurre.model';
import { Defaut } from './defaut.model';
import { Conditionnement } from '../../declaration/models/conditionnement.model';
import { Produit } from '../../habilitation/models/produit.model';
import { DataIdArrayConverterFactory, DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class Leurre {
    static jsonMap = {
        id: { key: 'id', optional: true },
        codeProduit: { key: 'codeProduit' },
        millesime: { key: 'millesime' },
        type: { key: 'idType', converter: new (DataIdConverterFactory.build(TypeLeurre, 'typesLeurres'))(), optional: true },
        defauts: { key: 'idsDefauts', converter: new (DataIdArrayConverterFactory.build(Defaut, 'defauts'))(), optional: true },
        conditionnement: {
            key: 'idConditionement',
            converter: new (DataIdConverterFactory.build(Conditionnement, 'conditionnements'))(),
            optional: true
        }
    };

    id: number;
    codeProduit: string;
    millesime: number;
    type: TypeLeurre;
    defauts: Defaut[];
    conditionnement: Conditionnement;

    produit: Produit;
    cahier: string;
    couleur: string;
}
